
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ToDoMasterGrid extends Serenity.EntityGrid<ToDoMasterRow, any> {
        protected getColumnsKey() { return 'OMS.ToDoMaster'; }
        protected getDialogType() { return ToDoMasterDialog; }
        protected getIdProperty() { return ToDoMasterRow.idProperty; }
        protected getLocalTextPrefix() { return ToDoMasterRow.localTextPrefix; }
        protected getService() { return ToDoMasterService.baseUrl; }
        protected getInsertPermission() { return CustomerRow.insertPermission; }
        protected getUpdatePermission() { return CustomerRow.updatePermission; }


        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}